import { useState } from "react";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import FormGroup from "./FormGroup.js";
import ButtonGrid from "./ButtonGrid.js";

export default function SigninModal (props)
{
    const [validated, setValidated] = useState(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [institution, setInstitution] = useState("");
    const [mailAddress, setMailAddress] = useState("");
    const [password, setPassword] = useState("");

    function handleFirstNameChange (e) { setFirstName(e.target.value); }
    function handleLastNameChange (e) { setLastName(e.target.value); }
    function handleInstitutionChange (e) { setInstitution(e.target.value); }
    function handleMailAddressChange (e) { setMailAddress(e.target.value); }
    function handlePasswordChange (e) { setPassword(e.target.value); }

    function reset ()
    {
	setFirstName("");
	setLastName("");
	setInstitution("");
	setMailAddress("");
	setPassword("");
    }
    
    function hide ()
    {
	props.hide();
	setValidated(false);
    }
    
    function handleHide (e) { hide(); }

    function handleSubmit (e)
    {
	e.preventDefault();
	if (e.target.checkValidity()) {
	    props.submit({ firstName, lastName, institution, mailAddress, password });
	    reset();
	    hide();
	}

	else setValidated(true);
    }

    return (
	<Modal
	    show={props.show}
	    onHide={handleHide}
	    backdrop="static"
	    centered
	>
	    <Modal.Header>
		<Modal.Title>Création d'un nouveau compte</Modal.Title>
	    </Modal.Header>
	    <Modal.Body>
		<Form
		    id="signinForm"
			noValidate validated={validated}
			onSubmit={handleSubmit}
		    className="d-flex flex-column gap-3"
		>
		    <FormGroup formID="signinForm" controlId="lastName" label="Nom">
			<Form.Control
			    type="text"
			    required
			    autoFocus
			    value={lastName}
			    onChange={handleLastNameChange}
			/>
		    </FormGroup>
		    
		    <FormGroup formID="signinForm" controlId="firstName" label="Prénom">
			<Form.Control
			    type="text"
			    required
			    value={firstName}
			    onChange={handleFirstNameChange}
			/>
		    </FormGroup>

		    <FormGroup formID="signinForm" controlId="institution" label="Établissement">
			<Form.Control
			    type="text"
			    required
			    value={institution}
			    onChange={handleInstitutionChange}
			/>
		    </FormGroup>

		    <FormGroup formID="signinForm" controlId="mailAddress" label="Adresse courriel">
			<Form.Control
			    type="text"
			    required
			    value={mailAddress}
			    onChange={handleMailAddressChange}
			/>
		    </FormGroup>

		    <FormGroup formID="signinForm" controlId="password" label="Mot de passe">
			<Form.Control
			    type="password"
			    required
			    value={password}
			    onChange={handlePasswordChange}
			/>
		    </FormGroup>

		</Form>
	    </Modal.Body>
	    
	    <Modal.Footer>
		<ButtonGrid>
		    <ButtonGrid.Left>
			<Button variant="outline-secondary" size="md" onClick={handleHide}>Annuler</Button>
		    </ButtonGrid.Left>
		    <ButtonGrid.Right>
			<Button variant="primary" size="md" type="submit" form="signinForm">Enregistrer</Button>
		    </ButtonGrid.Right>
		</ButtonGrid>
	    </Modal.Footer>
	</Modal>
    );
}
